export const DEFAULT_CATALOG_UI = {
  searchText: '',
  materialKey: null,
  coatingKey: null,
  expandedGroups: {},
}

const CATALOG_UI_KEYS = ['searchText', 'materialKey', 'coatingKey', 'expandedGroups']

const isValidSearchText = value => typeof value === 'string'

const isValidFilterKey = value => value === null || typeof value === 'string'

const isValidExpandedGroups = value =>
  value != null && typeof value === 'object' && !Array.isArray(value)

const isSameExpandedGroups = (a, b) => {
  const keysA = Object.keys(a)
  const keysB = Object.keys(b)
  if (keysA.length !== keysB.length) return false
  return keysA.every(key => a[key] === b[key])
}

/**
 * Apply a partial catalogUi patch with key allowlist and value checks.
 * Unknown keys and invalid values are ignored. Stable no-op when unchanged.
 * `expandedGroups` is replaced (callers pass the next full map).
 */
export const applyCatalogUiPatch = (catalogUi, patch) => {
  if (patch == null || typeof patch !== 'object' || Array.isArray(patch)) {
    return catalogUi
  }

  const next = { ...catalogUi }
  let changed = false

  for (const key of CATALOG_UI_KEYS) {
    if (!Object.prototype.hasOwnProperty.call(patch, key)) continue

    const value = patch[key]
    let accepted = false

    if (key === 'searchText') {
      accepted = isValidSearchText(value)
    } else if (key === 'materialKey' || key === 'coatingKey') {
      accepted = isValidFilterKey(value)
    } else if (key === 'expandedGroups') {
      accepted = isValidExpandedGroups(value)
    }

    if (!accepted) continue

    if (key === 'expandedGroups') {
      if (isSameExpandedGroups(next.expandedGroups, value)) continue
      next.expandedGroups = { ...value }
      changed = true
      continue
    }

    if (next[key] === value) continue
    next[key] = value
    changed = true
  }

  return changed ? next : catalogUi
}
